<script lang="ts">
  import type { Pages } from "@packages/utils/enums";
  import ContentHeader from "../shared/ContentHeader.svelte";
  import NavMenuContent from "./NavMenuContent.svelte";

  export let options: {
    onClick: (page: Pages) => void;
    showAssets?: boolean;
  };

  let { onClick, showAssets = false } = options;
</script>

<div class="crtw-w-full crtw-flex crtw-flex-col">
  <ContentHeader text="Navigation Menu" />

  <!-- Menu items -->
  <NavMenuContent {onClick} {showAssets} />
</div>
